module.exports = __webpack_public_path__ + "img/Mortgage.28439a8d.svg";